module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAtMAAAAyCAYAAACec1c/AAABW0lEQVR4nO3WMUpDURRF0ZsfqzRaOwVBh6BDdwoRnIK1lZVRSfjCr3cXWAse9/Sv2bvj8+0yM7uZOd+z/bqXzb7Z3P16L+/x9fP96+M4AABwTQ73T/P2cvcwM9+bd1r3z+ae1vu/Z92/ix8HAIBGTAMAQCSmAQAgEtMAABCJaQAAiMQ0AABEYhoAACIxDQAAkZgGAIBITAMAQCSmAQAgEtMAABCJaQAAiMQ0AABEYhoAACIxDQAAkZgGAIBITAMAQCSmAQAgEtMAABCJaQAAiMQ0AABEYhoAACIxDQAAkZgGAIBITAMAQCSmAQAgEtMAABCJaQAAiMQ0AABEYhoAACIxDQAAkZgGAIBITAMAQCSmAQAgEtMAABCJaQAAiMQ0AABEYhoAACIxDQAAkZgGAIBITAMAQCSmAQAgEtMAABCJaQAAiMQ0AABEYhoAACIxDQAAkZgGAIBiZv4A4gAWheEVLesAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/invitation/index/image/ZJ2.png
// module id = 304
// module chunks = 0